import { Flex, FloraTypography } from '@grupoboticario/flora-react'

import { getShortCutInformation, getColor } from './functions'
import * as S from './InformationBox.styles'

const InformationBox = ({ expirationDate, isBlocked, lastTransactionPoints, tier, totalPoint }) => {
  const shortcutInformation = getShortCutInformation({
    expirationDate,
    isBlocked,
    lastTransactionPoints,
    tier,
    totalPoint
  })
  return shortcutInformation.map(({ title, value, hasColor, isBlocked, key }) => (
    <Flex css={S.cardCss} direction="column" gap="$2" justify="center" key={key}>
      <FloraTypography fontSize="exceptionsAuxiliar">{title}</FloraTypography>
      <Flex align="baseline" gapX="$1">
        <FloraTypography as="h5" css={S.getDynamicColorCss(getColor(hasColor, value, isBlocked))} fontSize="title">
          {value}
        </FloraTypography>
        {!!isBlocked && (
          <FloraTypography css={S.errorTextCss} fontSize="exceptionsAuxiliar">
            (bloqueado)
          </FloraTypography>
        )}
      </Flex>
    </Flex>
  ))
}

export default InformationBox
